import { Texts as componentsTexts } from '@jablotron/lib.spa-components';
import { Texts as formsTexts } from '@jablotron/lib.spa-forms';
import { languages } from '@jablotron/lib.spa-lang';
import { Texts as zodValidatorTexts } from '@jablotron/lib.zod-validator';
import { languageCodes } from '~/texts/languages';
import { uiTexts } from '~/texts/ui';
import { addProjectPrefix } from '~/utils/texts';

enum PROJECT {
  WEB_COMMON = 'WebCommon',
  WEB_PRODUCT_CATALOG = 'WebProductCatalog',
}

export const Languages: readonly (keyof typeof languages)[] = languageCodes;

/** Shared strings — same English sources as web.indexa-registration / COMMON. */
const webCommonTexts = {
  GDPR: 'GDPR',
  TermsOfService: 'Terms of service',
  ContactUs: 'Contact us',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  SwitchLanguage: 'Switch language',
  ChangeLanguage: 'Select the language you want to use in the application',
  InvalidEmail: 'Invalid email address',
  RequiredField: '{{label}} is required',
  TooManyRequestsErrorMessage: 'Too many requests, please try again later.',
  PageDoesNotExistTitle: 'This page does not exist',
  GoToHomePage: 'Go to home page',
  Loading: 'Loading',
};

/**
 * The keys the app looks up by name. The catalog texts (catalog.generated.ts, ~8 400 keys) aren't here:
 * the catalog data carries its terms as strings, so the app never needs their names, and leaving them
 * out keeps 1.6 MB out of the bundle. src/texts.ts adds them for `yarn translations:get`.
 */
export const Texts = {
  ...componentsTexts,
  ...formsTexts,
  ...zodValidatorTexts,
  ...addProjectPrefix(PROJECT.WEB_COMMON, webCommonTexts),
  ...addProjectPrefix(PROJECT.WEB_PRODUCT_CATALOG, uiTexts),
};

export { PROJECT };
